(function () {
  'use strict';

  angular.module('sempraWebapp').service('washBoxKarcherUtils', washBoxKarcherUtilsService);

  /** @ngInject */
  function washBoxKarcherUtilsService (modelUtils, PointTypeEnum) {
    var that = this;

    this.getWashBoxPoint = function (facilityJson, boxName) {
      return facilityJson.points.find(function (pointJson) {
        return pointJson.pointType === PointTypeEnum.KARCHER_WASH_BOX
          && pointJson.name === boxName;
      });
    };

    this.getWashBoxPoints = function (facilityJson) {
      return facilityJson.points.filter(function (pointJson) {
        return (pointJson.pointType === PointTypeEnum.KARCHER_WASH_BOX);
      });
    };

    this.getFeedValue = function (pointJson, feedReference) {
      return that.FeedReferencesProperties[feedReference].getValue(pointJson);
    };

    this.getFeed = function (pointJson, feedReference) {
      return that.FeedReferencesProperties[feedReference].getFeed(pointJson);
    };

    this.getActuatorValue = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getValue(pointJson);
    };

    this.getActuator = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getActuator(pointJson);
    };

    this.FeedReferences = {
      TURNOVER: 'TURNOVER',
      TURNOVER_MANUAL_TOKEN: 'TURNOVER_MANUAL_TOKEN',
      STATUS_BAY_AVAILABILITY: 'STATUS_BAY_AVAILABILITY',
      STATUS_BAY_RUN_TIME: 'STATUS_BAY_RUN_TIME',
      STATUS_BAY_CREDIT: 'STATUS_BAY_CREDIT',
      STATUS_BAY_ACTIVE_PROGRAM_ID: 'STATUS_BAY_ACTIVE_PROGRAM_ID',
      STATUS_BAY_ACTIVE_PROGRAM_NAME: 'STATUS_BAY_ACTIVE_PROGRAM_NAME',
      PUMP_TYPE: 'PUMP_TYPE',
      OP_CC_ZETONI: 'OP_CC_ZETONI',
      OP_CC_KOVANICE: 'OP_CC_KOVANICE'
    };

    this.FeedReferencesProperties = {
      TURNOVER: getFeedPropertiesObject('TURNOVER'),
      TURNOVER_MANUAL_TOKEN: getFeedPropertiesObject('TURNOVER_MANUAL_TOKEN'),
      STATUS_BAY_AVAILABILITY: getFeedPropertiesObject('STATUS_BAY_AVAILABILITY'),
      STATUS_BAY_RUN_TIME: getFeedPropertiesObject('STATUS_BAY_RUN_TIME'),
      STATUS_BAY_CREDIT: getFeedPropertiesObject('STATUS_BAY_CREDIT'),
      STATUS_BAY_ACTIVE_PROGRAM_ID: getFeedPropertiesObject('STATUS_BAY_ACTIVE_PROGRAM_ID'),
      STATUS_BAY_ACTIVE_PROGRAM_NAME: getFeedPropertiesObject('STATUS_BAY_ACTIVE_PROGRAM_NAME'),
      PUMP_TYPE: getFeedPropertiesObject('PUMP_TYPE'),
      OP_CC_ZETONI: getFeedPropertiesObject('OP_CC_ZETONI'),
      OP_CC_KOVANICE: getFeedPropertiesObject('OP_CC_KOVANICE')
    }

    this.ActuatorReferences = Object.freeze({
      OP_BUTTON: 'OP_BUTTON',
      DISABLED: 'DISABLED',
      properties: {
        OP_BUTTON: getActuatorPropertiesObject('OP_BUTTON'),
        DISABLED: getActuatorPropertiesObject('DISABLED')
      }
    });

    // Setting dynamic references - begin ====================================================================================================

    var programName = 'PROGRAM_NAME_', programCounter = 'PROGRAM_COUNTER_',
        washBoxId = 'SETUP_UNIT_BAY_PROGRAM_ID_', washBoxProgramName = 'SETUP_UNIT_BAY_PROGRAM_NAME_',

    // ----------------
        i, j;

    for(i=0; i<8; i++) {
      this.FeedReferences[programName + i] = programName + i;
      this.FeedReferences[programCounter + i] = programCounter + i;
      this.FeedReferencesProperties[programName + i] = getFeedPropertiesObject(programName + i);
      this.FeedReferencesProperties[programCounter + i] = getFeedPropertiesObject(programCounter + i);
    }

    for(j=0; j<12; j++) {
      this.FeedReferences[washBoxId + j] = washBoxId + j;
      this.FeedReferences[washBoxProgramName + j] = washBoxProgramName + j;
      this.FeedReferencesProperties[washBoxId + j] = getFeedPropertiesObject(washBoxId + j);
      this.FeedReferencesProperties[washBoxProgramName + j] = getFeedPropertiesObject(washBoxProgramName + j);
    }

    // Setting dynamic references - end ====================================================================================================

    function getFeedPropertiesObject (feedReference) {
      return {
        getValue: function (washBoxPointJson) {
          return modelUtils.getFeedCurrentValue(washBoxPointJson, feedReference);
        },
        getFeed: function (washBoxPointJson) {
          return modelUtils.getFeed(washBoxPointJson, feedReference);
        }
      }
    }

    function getActuatorPropertiesObject (actuatorReference) {
      return {
        getValue: function (washBoxPointJson) {
          return modelUtils.getActuatorCurrentValue(washBoxPointJson, actuatorReference);
        },
        getActuator: function (washBoxPointJson) {
          return modelUtils.getActuator(washBoxPointJson, actuatorReference);
        }
      }
    }
  }
})();
